import React, { useEffect, useState } from 'react';
import Icon from '../forms/Icon';
import { YYYYMMDD, formatDateToHTML } from '../utility/functions';
import Input from '../forms/Input';
import HamQuest from '../api/HamQuestGiver';
import Form from '../forms/Form';
import Row from '../layout/Row';
import Modal from '../Modal';
import Select from '../forms/Select';
import { useGlobalState } from '../stateProvider/StateProvider';
import ModalFactory from '../Modal';

const DateRange = ({ route, setData, reportCallback, searchLimit = 398, setTableLoading, byLocation, ...props }) => {
    const {
        state: {
            locations
        },
    } = useGlobalState();

    searchLimit = 396;

    useEffect(() => {
        if (route)
            window.DateRange();
    }, [])

    const [loading, setLoading] = useState(false);

    const offsetUTC = (date) => {
        const localDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
        return localDate.toISOString().split('T')[0];
    }

    const fetchData = (start, end, locationId) => {
        setLoading(true);

        const body = (start && end) ? {
            startDate: offsetUTC(start),
            endDate: offsetUTC(end),
        } : {}

        if (locationId) body.locationId = locationId;

        HamQuest.getQuery(route, body)
            .then(res => {
                if (reportCallback) {
                    reportCallback(res, setData)
                } else {
                    setData(res)
                }
            })
            .catch(ex => {
                setTableLoading(false);
                ModalFactory.catch(ex)
            })
            .finally(() => setLoading(false))
    }

    // window.fetchTableData = fetchData(startDate, endDate)

    const filterSearch = (e) => {
        const startDate = new Date(e.startDate);
        const endDate = new Date(e.endDate);
        const location = e.location;
        const daysDifference = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
        if (daysDifference > (searchLimit)) {
            return false;
        }
        fetchData(startDate, endDate, location);
    }

    const m30 = (date) => {
        const result = new Date(date);
        result.setDate(result.getDate() - 30);
        return formatDateToHTML(result);
    }

    return (
        <Row align='flex-end' wrap>
            <Form
                inputs={{
                    startDate: formatDateToHTML(props.startDate || new Date(), (props.monthStart ?? true)),
                    endDate: formatDateToHTML(),
                    location: ''
                }}
                style={{ alignItems: 'flex-end' }}
                onSubmit={(e, setError) => {
                    if (filterSearch(e) === false) {
                        setError(`Please set a valid date range. ${searchLimit} days`)
                    } else {
                        setError('')
                    }
                }}
                text='Search'
                buttonstyle={{ marginBottom: '0.2em' }}
                localForm
                row
                windowSubmission='DateRange'
            >
                {({ values, setValues }) => (
                    <Row wrap>
                        <Input
                            label='Start Date'
                            name='startDate'
                            type='date'
                            max={values.endDate}
                            required

                            onBlur={() => {
                                const daysDifference = (new Date(values.endDate).getTime() - new Date(values.startDate).getTime()) / (1000 * 60 * 60 * 24);
                                if (daysDifference > (searchLimit)) {
                                    const result = new Date(values.startDate);
                                    result.setDate(result.getDate() + searchLimit);

                                    setValues(v => ({
                                        ...v,
                                        endDate: YYYYMMDD(result)
                                    }))
                                }
                            }}
                        />
                        <Input
                            label='End Date'
                            name='endDate'
                            type='date'
                            min={values.startDate}
                            max={YYYYMMDD(new Date())}
                            required

                            onBlur={() => {
                                const daysDifference = (new Date(values.endDate).getTime() - new Date(values.startDate).getTime()) / (1000 * 60 * 60 * 24);
                                if (daysDifference > (searchLimit)) {
                                    const result = new Date(values.endDate);
                                    result.setDate(result.getDate() - searchLimit + 1);

                                    setValues(v => ({
                                        ...v,
                                        startDate: YYYYMMDD(result)
                                    }))
                                }
                            }}
                        />

                        {byLocation && (
                            <Select
                                label='Location'
                                name='location'
                                options={locations}
                                nullable
                            />
                        )}
                    </Row>
                )}
            </Form>
            {loading && <Icon style={{ marginBottom: '0.5em' }} icon='spinner' />}
        </Row>
    );
}


export default DateRange;